import React, { memo, useMemo } from 'react';
import clsx from 'clsx';
import { DelayedContent } from '../delayed-content';
import styles from './styles.module.css';
export const Skeleton = /*#__PURE__*/memo(({
  className = '',
  width,
  height
}) => {
  const style = useMemo(() => ({
    ...(width && {
      width
    }),
    ...(height && {
      height
    })
  }), [width, height]);
  return /*#__PURE__*/React.createElement(DelayedContent, null, /*#__PURE__*/React.createElement("div", {
    className: clsx(className, styles.skeleton),
    style: style
  }));
});